import React, { useState } from "react";
import { Drawer, Layout } from "antd";

import SidebarContent from "./SidebarContent";

import "./layoutStyle.css";

const { Sider } = Layout;

const AppSideBar = (props) => {
  const {
    sidebarCollapsed,
    setSidebarCollapsed,
    navCollapsed,
    setNavCollapsed,
  } = props;
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", () => {
    setWidth(window.innerWidth);
  });

  return (
    <Sider
      className={`gx-app-sidebar gx-layout-sider-dark`}
      trigger={null}
      collapsed={sidebarCollapsed ? true : false}
      theme={"dark"}
      collapsible
    >
      {1 !== 1 || width < 992 ? (
        <Drawer
          className={`gx-drawer-sidebar gx-drawer-sidebar-dark`}
          placement="left"
          closable={false}
          onClose={() => setNavCollapsed(!navCollapsed)}
          visible={navCollapsed}
        >
          <SidebarContent
            sidebarCollapsed={sidebarCollapsed}
            setSidebarCollapsed={setSidebarCollapsed}
          />
        </Drawer>
      ) : (
        <SidebarContent
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        />
      )}
    </Sider>
  );
};
export default AppSideBar;